/** The first route from the URL (docs/spec/05 §5). */

import type { PlayRequest, Route } from '../ui/scene';
import { num, pick, query } from './params';

const SCREENS = ['title', 'daily', 'options', 'controls', 'hiscores', 'help', 'credits'] as const;
const MODES = ['supernova', 'classic', 'daily', 'demo'] as const;

export function bootRoute(): Route {
  if (query.has('demo')) return { to: 'play', request: { mode: 'demo' } };
  if (query.has('play')) {
    const request: PlayRequest = {
      mode: pick('play', MODES, 'supernova'),
      ...(query.has('stage') ? { stage: Math.max(1, Math.round(num('stage', 1))) } : {}),
      ...(query.has('seed') ? { seed: Math.round(num('seed', 1)) } : {}),
      ...(query.has('lives') ? { fighters: Math.max(1, Math.round(num('lives', 3))) } : {}),
    };
    return { to: 'play', request };
  }
  const screen = query.get('screen');
  if (screen === 'initials') {
    // For looking at the screen: a score to sign for.
    return { to: 'initials', entry: { table: pick('table', ['supernova', 'classic'] as const, 'supernova'), score: num('score', 48_250), stage: 9 } };
  }
  if (screen === 'hiscores') return { to: 'hiscores', table: pick('table', ['supernova', 'classic'] as const, 'supernova') };
  if (screen && (SCREENS as readonly string[]).includes(screen)) return { to: screen as (typeof SCREENS)[number] };
  return { to: 'title' };
}
